module.exports = __webpack_public_path__ + "static/media/socialNetwork.bd64e649.svg";